<template>
    <div>
        <div class="xinz">
            <div class="right">
                <router-link tag='a' :to="'/jobAdd'" style="text-decoration: none;color: #fff;"><el-button type="warning"  v-if="canAdd"><i class="fa fa-plus" /> 新增工作單</el-button></router-link>
            </div>
        </div>
        <div>
            <el-form :inline="true"  class="demo-form-inline" @keyup.native.enter="getJobOrderList" size="small">
                <el-form-item label="搜索條件：">
                    <el-input placeholder="工作單號/客戶"  v-model="serchJobNO" clearable>
                    </el-input>
                </el-form-item>
               <!-- <el-form-item label="">
                    <el-input placeholder="客戶"  v-model="serchCustNO" clearable>
                </el-input>
                </el-form-item>-->
                <el-form-item label="">
                    <el-date-picker
                            v-model="searchDate"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="~"
                            start-placeholder="工作日期"
                            end-placeholder="工作日期"
                            value-format="timestamp"
                            :picker-options="pickerOptions2" style="width:260px;color: #4B78FF">
                    </el-date-picker>
                </el-form-item>
                <!--<el-form-item >
                    <el-date-picker
                            v-model="getFeedDate"
                            type="date"
                            placeholder="選擇日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item >
                    <el-select v-model="serchStatus" placeholder="狀態" style="width:150px;" clearable>
                        <el-option value="0" label="未入倉"></el-option>
                        <el-option value="1" label="已入倉"></el-option>
                    </el-select>
                </el-form-item>-->
                <el-form-item>
                    <el-button type="primary" @click="getJobOrderList()"><i class="fa fa-search" /> {{$t('m.b_query')}}</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <el-table :header-cell-style="{background:'#4B78FF',color:'#FFFFFF'}"
                      v-loading="tableloading"
                      @selection-change="handleSelectionChange"
                      :data="custTaskList"
                      :empty-text="$t('m.t_nodata')"
                      stripe
                      border
                      class="dataListTable">

                <el-table-column
                        prop="jobNo"
                        align="left"
                        width="120"
                        label="工作單號">
                    <template slot-scope="scope">
                        <template v-if="scope.row.countNum!=0">
                            {{scope.row.jobNo}}&nbsp;*
                        </template>
                        <template v-else>
                            {{scope.row.jobNo}}
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="custNo"
                        align="left"
                        label="客戶">
                    <template slot-scope="scope">
                       {{scope.row.custNo}}/{{scope.row.custName}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="service"
                        align="left"
                        width="70"
                        label="類型">
                </el-table-column>
                <el-table-column
                        prop="dest"
                        align="left"
                        label="目的地">
                </el-table-column>
                <el-table-column
                        prop="startDate"
                        align="left"
                        width="110"
                        label="工作日期">
                    <template slot-scope="scope">
                        <template v-if="scope.row.startDate!=0">
                            {{scope.row.startDate*1000 | date('%Y-%m-%d') }}
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="jobDetail"
                        align="left"
                        label="工作內容">
                </el-table-column>
                <el-table-column
                        prop="id"
                        align="center"
                        width="100"
                        :label="$t('m.b_opt')">
                    <template slot-scope="scope">
                        <template>
                            <el-dropdown>
                                <el-button size="small" type="primary">
                                    <i class="fa fa-mouse-pointer"/> {{$t('m.b_opt')}}
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item size="small" type="primary" @click.native="feedBackEdit(scope.row)" v-if="canEdit"><i class="fa fa-edit"/>{{$t('m.b_edit')}}</el-dropdown-item>
                                    <el-dropdown-item size="small" type="primary" @click.native="feedBackPrint(scope.row)" v-if="canPrint"><i class="fa fa-edit"/>卡板箱號管理</el-dropdown-item>
                                    <el-dropdown-item  @click.native="pdfBaseDownload(scope.row)" v-if="canPdf"><i class="fa fa-file-pdf-o"/>Loading Chart</el-dropdown-item>
                                    <el-dropdown-item  @click.native="pdfDownload(scope.row,1)" v-if="canWord"><i class="fa fa-file-pdf-o"/>工作單下載</el-dropdown-item>
                                    <el-dropdown-item  @click.native="pdfDownload(scope.row,2)" v-if="canHouse"><i class="fa fa-file-pdf-o"/>回倉纸下載</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination">
            <el-pagination
                    layout="total, prev, pager, next"
                    @current-change="custTaskPageChange"
                    :current-page.sync="pager.page"
                    :page-size="pager.size"
                    :total="pager.total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import {getJobOrderList} from '../api/api'
    export default {
        data() {

            return {
                pickerOptions0:{
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                pickerOptions2: {
                    shortcuts: [{
                        text: this.$t('m.t_lastweek'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: this.$t('m.t_lastmonth'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: this.$t('m.t_lastthreemonth'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                //查詢條件
                serchJobNO:"",
                serchCustNO:'',
                serchStatus:'',
                getFeedDate:'',
                searchDate:'',
                selectionItems:[],
                pager:{
                    page:0,
                    size:10,
                    total:0
                },
                custTaskList:[],
                dialogName:'',
                tableloading:false,
            }
        },
        methods: {
            pdfBaseDownload(value){
                var url=axios.defaults.baseURL+"/excel/jobPdf?jobId="+value.id+"&token="+ this.$store.getters.staff.token;
                window.location.href=url;
            },
            pdfDownload(value,type){
                //var url=axios.defaults.baseURL+"/excel/jobOrder?rollId="+value.id+"&token="+ this.$store.getters.staff.token;
                var url=axios.defaults.baseURL+"/word/job?jobId="+value.id+"&token="+ this.$store.getters.staff.token+"&type="+type;
                window.location.href=url;
            },
            handleSelectionFileChange(){},
            handleFileListChange(val){
            },

            custTaskPageChange(val){
                this.getJobOrderList();
            },handleItemChange(val){
            },
            handleSelectionChange(val){
                this.selectionItems=val;
            },
            getJobOrderList(){
                this.tableloading=true;
                var params={page:this.pager.page,size:this.pager.size,jobNo:this.serchJobNO.trim(),custNo:this.serchCustNO.trim()};
               /* if(params.feedDate!=null && params.feedDate!=''){
                    params.feedDate = parseInt(new Date(params.feedDate).getTime()/1000);
                }*/
                if(this.searchDate!=null&&this.searchDate!=""){
                    params.startDate=Math.round(new Date(this.searchDate[0]).getTime()/1000);
                    params.endDate=Math.round(new Date(this.searchDate[1]).getTime()/1000);
                }
                return getJobOrderList(params).then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode==200){
                        let {size,page,total,data:items=[]}=res.data;
                        this.custTaskList=items;
                        this.pager.total=total;
                        this.pager.page=page;
                        this.pager.size=size;
                        this.tableloading=false;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },
            feedBackEdit(row){
                this.$router.push({
                    name:'編輯工作單',
                    params:{
                        jobId:row.id
                    }
                })
                var path="/jobEdit/"+row.id
                this.$router.push(path);
            },
            feedBackPrint(row){
                this.$router.push({
                    name:'卡板箱号管理',
                    params:{
                        id:row.id,
                        jobId:row.jobId
                    }
                })
                var path="/jobPrint/"+row.id+"/"+row.jobId
                this.$router.push(path);
            },
            resetForm(formName){
                if (this.$refs[formName]!==undefined) {
                    this.$refs[formName].resetFields();
                }
            }
        },
        mounted() {
        },
        activated(){
            this.getJobOrderList();

        },
        computed: {
            canAdd(){
                return this.$store.getters.hasPermission("JOB_ADD");
            },
            canEdit(){
                return this.$store.getters.hasPermission("JOB_EDIT");
            },
            canPrint(){
                return this.$store.getters.hasPermission("JOB_PRINT");
            },
            canWord(){
                return this.$store.getters.hasPermission("JOB_WORD");
            },
            canHouse(){
                return this.$store.getters.hasPermission("JOB_HOUSE");
            },
            canPdf(){
                return this.$store.getters.hasPermission("JOB_PDF");
            },
        }
    }

</script>

<style lang="scss">
    .menu{
        .right{
            float: right;
        }
    }
    .el-tag + .el-tag {
        margin-left: 5px;
    }
    .dataListTable .cell{ white-space:nowrap; }
</style>



// WEBPACK FOOTER //
// src/views/JobOrderList.vue